import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const LongArrowLeft24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8186 11.7626C20.8186 12.2459 20.4268 12.6376 19.9436 12.6376L5.45762 12.6376C4.97437 12.6376 4.58262 12.2459 4.58262 11.7626C4.58262 11.2794 4.97437 10.8876 5.45762 10.8876L19.9436 10.8876C20.4268 10.8876 20.8186 11.2794 20.8186 11.7626Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.30547 17.068C8.96376 17.4097 8.40974 17.4097 8.06803 17.068L3.3814 12.3813C3.21731 12.2172 3.12512 11.9947 3.12512 11.7626C3.12512 11.5306 3.21731 11.308 3.3814 11.1439L8.06803 6.45727C8.40974 6.11556 8.96376 6.11556 9.30547 6.45727C9.64718 6.79898 9.64718 7.353 9.30547 7.69471L5.23756 11.7626L9.30547 15.8305C9.64718 16.1722 9.64718 16.7262 9.30547 17.068Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
